import Box from '@mui/material/Box';
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { useIsMobileShell } from '../../hooks/useIsMobileShell';
import { isAiChatEnabled } from '../../services/aiChat';
import AiChatPanel from '../aichat/AiChatPanel';
import AppBarCustom from './AppBar';
import MobileLayout from './MobileLayout';
import ModernSidebar from './ModernSidebar';

/**
 * App shell — DESIGN-SYSTEM.md §3 (App shell).
 *
 * Sidebar + topbar + content area, wrapping every screen except the
 * full-screen "operate" routes (Nova Venda/POS), which stay outside this
 * component entirely per §3.4 — see `DefaultRouter.js`, `/sale` is a
 * sibling route, not a child of this shell.
 *
 * The actual MUI theme (palette/typography/shape/component overrides) is
 * provided once, globally, in `App.js` via `theme/theme.js` — this
 * component only lays out the shell chrome.
 */
export default function MainV2() {
    // Celular: shell próprio (AppBar + barra inferior), espelhando o fv-app.
    // Desktop/tablet seguem exatamente com o shell abaixo.
    const isMobileShell = useIsMobileShell();
    if (isMobileShell) return <MobileLayout />;

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: 'background.default' }}>
            <ModernSidebar />
            <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
                <AppBarCustom />
                <Box
                    component="main"
                    sx={{
                        flex: 1,
                        width: '100%',
                        maxWidth: 1440,
                        mx: 'auto',
                        p: { xs: 2, md: 3 },
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
            {/* Assistente de IA (painel lateral). Só existe com REACT_APP_AI_ENABLED=true. */}
            {isAiChatEnabled() && <AiChatPanel />}
        </Box>
    );
}
